import { useEffect, useState } from 'react'
import { i18n } from '@fs/zion-locale'
import { useSlsStateContext } from '@fs/zion-sls'
import { errorCollector } from '../../shared/utils/utils'
import { getSourceLanguage, translateWithTranslatedApi } from './useTranslate.utils'

export default function useTranslate({ showingTranslation, plainTextTranscript, artifact, group }) {
  const state = useSlsStateContext()
  const [loadingTranslation, setLoadingTranslation] = useState(false)
  const [translations, setTranslations] = useState({})
  const [translationLoadErr, setTranslationLoadErr] = useState()

  useEffect(() => {
    const fetchTranslation = async () => {
      setLoadingTranslation(true)
      try {
        const targetLanguage = i18n.language
        const sourceLanguage = getSourceLanguage(artifact, group)
        const translatedText = await translateWithTranslatedApi(plainTextTranscript, sourceLanguage, targetLanguage)

        setTranslations({ ...translations, [state.currentImageArk]: translatedText })
        setLoadingTranslation(false)
      } catch (err) {
        errorCollector(err, state.currentImageArk, {
          codeId: 26,
        })
        setTranslationLoadErr(state.currentImageArk)
        setLoadingTranslation(false)
      }
    }

    const shouldFetch =
      showingTranslation &&
      plainTextTranscript &&
      artifact &&
      state.currentImageArk &&
      !translations[state.currentImageArk] &&
      !loadingTranslation &&
      translationLoadErr !== state.currentImageArk

    if (shouldFetch) {
      if (translationLoadErr) {
        setTranslationLoadErr(false)
      }
      fetchTranslation()
    }
  }, [
    showingTranslation,
    plainTextTranscript,
    artifact,
    group,
    translations,
    state,
    translationLoadErr,
    loadingTranslation,
  ])

  return {
    translationLoadErr,
    translations,
  }
}
